import { Grid, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { useRetrospectiva } from "../context/RetrospectivaContext"
import { ContainerInsta } from "./ContainerInsta"
import { wavesSvg } from "./Svg"

const useStyles = makeStyles(() => {
    return {
        cabecalho: {
            position: "relative",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginBottom: "30px",
            height: "auto",
            marginTop: "2rem",
        },
        logoContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
            paddingTop: "2.8rem",
        },
        logo: {
            width: "200px",
            height: "200px",
            borderRadius: "1.2rem",
            objectFit: "cover",
        },
        ano: {
            width: "100%",
            textAlign: "center",
            position: "absolute",
            top: "195px",
            fontSize: "60px",
            color: "white",
            fontWeight: "bold",
            textShadow: "0px 4px 12px rgba(0,0,0,0.6)",
        },
        retrospectiva: {
            width: "100%",
            textAlign: "center",
            position: "absolute",
            fontSize: "50px",
            color: "white",
            fontWeight: "bold",
            textShadow: "0px 4px 12px rgba(0,0,0,0.6)",
            whiteSpace: "nowrap",
        },
        dadosContainer: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: "auto",
            paddingBottom: "25px",
        },
        dadoItem: {
            textAlign: "center",
            padding: "0px 0px",
            minHeight: "80px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        },
        dadoLabel: {
            fontWeight: "bold",
            fontSize: "17px",
            textShadow: "0px 4px 12px rgba(0,0,0,0.6)",
            color: "white",
            marginBottom: "4px",
            lineHeight: 1.2,
        },
        dadoValue: {
            fontSize: "25px",
            fontWeight: "bold",
            textShadow: "0px 4px 12px rgba(0,0,0,0.6)",
            color: "white",
            lineHeight: 1,
        },
    }
})
export function Resumo() {
    const classes = useStyles()
    const dadosRestrospectiva = useRetrospectiva()

    const gradiente = "linear-gradient(180deg, #ff3366 0%, #ff0033 50%, #b30000 100%)"
    const formatacaoBRL = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })

    return (
        <ContainerInsta img={wavesSvg} gradiente={gradiente}>
            <div className={classes.cabecalho}>
                <Typography className={classes.retrospectiva}>Retrospectiva</Typography>

                <div className={classes.logoContainer}>
                    <img
                        src={dadosRestrospectiva?.estabelecimento.urlLogo}
                        alt="Logo"
                        className={classes.logo}
                    />
                </div>

                <Typography className={classes.ano}>2025</Typography>
            </div>

            <div className={classes.dadosContainer}>
                <Grid container spacing={1}>
                    <Grid item xs={6} className={classes.dadoItem}>
                        <Typography className={classes.dadoLabel}>Pedidos</Typography>
                        <Typography className={classes.dadoValue}>
                            {dadosRestrospectiva?.pedidos.quantidade}
                        </Typography>
                    </Grid>

                    <Grid item xs={6} className={classes.dadoItem}>
                        <Typography className={classes.dadoLabel}>Faturamento</Typography>
                        <Typography className={classes.dadoValue}>
                            {formatacaoBRL.format(dadosRestrospectiva?.pedidos.faturamento ?? 0)}
                        </Typography>
                    </Grid>

                    <Grid item xs={6} className={classes.dadoItem}>
                        <Typography className={classes.dadoLabel}>Clientes Fiéis</Typography>
                        <Typography className={classes.dadoValue}>
                            {dadosRestrospectiva?.clientes.clientesFieis}
                        </Typography>
                    </Grid>

                    <Grid item xs={6} className={classes.dadoItem}>
                        <Typography className={classes.dadoLabel}>Cliente Top 1º</Typography>
                        <Typography className={classes.dadoValue}>
                            {dadosRestrospectiva?.topClientes[0].nome}
                        </Typography>
                    </Grid>

                    <Grid item xs={6} className={classes.dadoItem}>
                        <Typography className={classes.dadoLabel}>Cartelas Resgatadas</Typography>
                        <Typography className={classes.dadoValue}>
                            {dadosRestrospectiva?.cartelasResgatadas}
                        </Typography>
                    </Grid>

                    <Grid item xs={6} className={classes.dadoItem}>
                        <Typography className={classes.dadoLabel}>Novos Clientes</Typography>
                        <Typography className={classes.dadoValue}>
                            {dadosRestrospectiva?.clientes.novosClientes}
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        </ContainerInsta>
    )
}
